/* tslint:disable */
/* eslint-disable */
/**
 * DynamicForms.Server | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PaletteFromJSON, PaletteToJSON, } from './Palette';
import { BackgroundFromJSON, BackgroundToJSON, } from './Background';
/**
 * Check if a given object implements the Theme interface.
 */
export function instanceOfTheme(value) {
    return true;
}
export function ThemeFromJSON(json) {
    return ThemeFromJSONTyped(json, false);
}
export function ThemeFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'palette': json['palette'] == null ? undefined : PaletteFromJSON(json['palette']),
        'background': json['background'] == null ? undefined : BackgroundFromJSON(json['background']),
        'id': json['id'] == null ? undefined : json['id'],
    };
}
export function ThemeToJSON(json) {
    return ThemeToJSONTyped(json, false);
}
export function ThemeToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'palette': PaletteToJSON(value['palette']),
        'background': BackgroundToJSON(value['background']),
        'id': value['id'],
    };
}
